<template>
  <div class="page-con">
    <div class="top-bg"></div>
    <div class="notice-con">
      <div class="con-title"><i class="icon icon1"></i><span>最新公告</span></div>
      <div class="text">{{ noticeText }}</div>
    </div>
    <div class="notice-con">
      <div class="con-title"><i class="icon icon2"></i><span>用户须知</span></div>
      <div class="text">1、云柑社区APP属于社区共享平台；</div>
      <div class="text">2、首页主要功能在于为社区用户提供自由交流的场所，自由发布、自由交易、自由分享，所有的物品置换和交易属于个人自愿行为，为此引起的纠纷需由您自行处理；</div>
      <div class="text">3、商圈主要功能在于为社区用户、企业商家提供商品或服务的展示与交易场所，所上架商品或服务均由云柑社区平台审核通过，如有交易纠纷请联系商圈客服；</div>
      <div class="text">4、感谢您的理解与支持！一起创建共信共享共赢的社区生态平台！</div>
    </div>
  </div>
</template>

<script>
  import { getCommunityNotice } from '@/api/anttalk/community'
  export default {
  data() {
    return {
      noticeText: '热烈庆祝云柑社区APP正式上线！',
    }
  },
  created() {
    if(this.$route.query.communityId){
      this.getCommunityNotice()
    }
  },
  methods: {
    // 获取社区公告
    getCommunityNotice(){
      getCommunityNotice({communityId: this.$route.query.communityId}).then(res=>{
        if(res.code===200 && res.data.length){
          let noticeObj = res.data[0]
          this.noticeText = noticeObj.content
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.page-con{
  position: absolute;top: 0;right: 0;bottom: 0;left: 0;z-index: -10;
  background-color: #814BF0;padding-top: 154.5px;
  .top-bg{
    position: fixed;top: 0;z-index: -9;
    width: 100%;height: 215.5px;
    background: url("https://fileqn.anttalk.vip/ant-wx/community/202012151038/顶部背景插画@2x.png") 50% 50% no-repeat;
    background-size: 100% 100%;
  }
  .notice-con{
    position: relative;margin: 0 auto;background-color: #fff;border-radius: 10px;
    width: 351px;min-height: 79.5px;margin-bottom: 15px;padding: 44px 0 18px;
    .con-title{
      display: flex;justify-content: center;align-items: center;
      position: absolute;top: -7px;left: 82.5px;
      width: 166.5px;height: 32px;
      background: url("https://fileqn.anttalk.vip/ant-wx/community/202012151038/标题背景@2x.png") 50% 50% no-repeat;
      background-size: 100% 100%;
      font-size: 18px;color: #fff;
      .icon{
        display: inline-flex;width: 17px;height: 17px;margin-right: 8px;
      }
      .icon1{
        background: url("https://fileqn.anttalk.vip/ant-wx/community/202012151038/最新公告icon@2x.png") 50% 50% no-repeat;
        background-size: 15px 100%;
      }
      .icon2{
        background: url("https://fileqn.anttalk.vip/ant-wx/community/202012151038/用户须知@2x.png") 50% 50% no-repeat;
        background-size: 15px 100%;
      }
    }
    .notice-text{
      padding: 44px 18px 19.5px;font-size: 16px;color: #333;
    }
    .text{
      font-size: 16px;color: #333;padding: 0 18px 0;line-height: 2;
    }
  }


  .img{
    display: block;
    width: 100%;
  }
}
</style>